import {
  Provider,
} from '@angular/core';

/**
 * Custom QR providers
 */
export function initializeCustomProviders(): Provider[] {
  return [];
}
